import { apiGet } from '../../api'

export const delete_group = group_id => {
  return apiGet({
    endpoint: `groups/delete_group?id=${group_id}`
  })
}
